'use strict';

export default class ShareActions {
    constructor() {
        this.generateActions(
            'loadShareSuccess',
            'loadError',
            'requestAccessSuccess',
            'requestAccessError',
            'toggleItemSelection',
            'toggleAllItems',
            'toggleDownloadAll',
            'downloadSuccess',
            'downloadError'
        );
    }
}



// WEBPACK FOOTER //
// ./app/actions/shareActions.js